import { BookServiceService } from 'src/app/services/book-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-post',
  templateUrl: './post.component.html',
  styleUrls: ['./post.component.scss']
})
export class PostComponent implements OnInit {
  id:any = this.router.snapshot.paramMap.get("id");
  book;

  constructor(
    private router : ActivatedRoute,
    private ser : BookServiceService,
    private route : Router
  ) { }

  public async getpost(){
    this.book =  await this.ser.onePost(this.id);
    console.log(this.book);

  }

  ngOnInit() {

    this.getpost();
   

  }
  back() {
    this.route.navigate(["/news"]);

  }

}
